import React from 'react'

import MerchandiseBrandsCarousel from '../MerchandiseCarousels/MerchandiseBrandsCarousel'
import MerchandiseCategoriesCarousel from '../MerchandiseCarousels/MerchandiseCategoriesCarousel'
import MerchandiseLandingPageHero from './MerchandiseLandingPageHero'
import MerchandiseOfferCarousel from '../MerchandiseCarousels/MerchandiseOfferCarousel'
import MerchandisePointsCarousel from '../MerchandiseCarousels/MerchandisePointsCarousel'
import MerchandiseBestOfBrandCarousel from '../MerchandiseCarousels/MerchandiseBestOfBrandCarousel'
import MerchandiseBestOfCategoryCarousel from '../MerchandiseCarousels/MerchandiseBestOfCategoryCarousel'
import MerchandiseRecentlyViewedCarousel from '../MerchandiseCarousels/MerchandiseRecentlyViewedCarousel'

const popularProductsFilters: App.MerchandiseFilters = {
  sortBy: 'recommended',
}

const topBrandsFilter: App.MerchandiseBrandFilters = {
  sortBy: 'top',
  limit: 20,
}

const topCategoriesFilter: App.MerchandiseCategoryFilters = {
  sortBy: 'top',
  level: 0,
  limit: 6,
}

/**
 * Temporary hardcoded carousels for the launch.
 * Will be replaced with a dynamic implementation in the future.
 */
const HOME_GARDEN_CATEGORY_ID = '7ef43fcc-9eb7-59c4-a091-1549d672f754'
const ELECTRONICS_CATEGORY_ID = 'a10eb183-c659-5256-8f4f-d150448c98e9'

const APPLE_CAROUSEL = 'Apple'
const SAMSONITE_CAROUSEL = 'Samsonite'
const SMEG_CAROUSEL = 'Smeg'

function MerchandiseLandingPage() {
  const trackingPageName = 'Landing Page'

  return <div>
    <MerchandiseLandingPageHero />
    <MerchandiseCategoriesCarousel
      title={<>Shop our <em>categories</em></>}
      viewAllTo="/shop/categories"
      filters={topCategoriesFilter}
    />
    <MerchandiseOfferCarousel
      title={<>Top products <em>for you</em></>}
      filters={popularProductsFilters}
      viewAllTo="/search/shop"
      trackingListName="Top products for you"
      trackingPageName={trackingPageName}
    />
    <MerchandiseBrandsCarousel
      title={<>Our top <em>brands</em></>}
      filters={topBrandsFilter}
      viewAllTo="/shop/brands"
    />
    <MerchandisePointsCarousel
      trackingPageName={trackingPageName}
    />
    <MerchandiseRecentlyViewedCarousel
      trackingPageName={trackingPageName}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={APPLE_CAROUSEL}
    />
    <MerchandiseBestOfCategoryCarousel
      trackingPageName={trackingPageName}
      categoryId={HOME_GARDEN_CATEGORY_ID}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={SAMSONITE_CAROUSEL}
    />
    <MerchandiseBestOfCategoryCarousel
      trackingPageName={trackingPageName}
      categoryId={ELECTRONICS_CATEGORY_ID}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={SMEG_CAROUSEL}
    />
  </div>
}

export default MerchandiseLandingPage
